// Set at integration time to the portal's login URL (e.g. https://portal.<domain>/login).
// Until then it points at the Contact page, exactly as the design does. Used in
// five places: utility bar, header button, mobile menu, footer, Contact page.
export const PORTAL_URL = '/contact';

// Draft markers flag copy the client has not approved yet. They show while
// developing so reviewers can see what is still open, and never in production.
// VITE_SHOW_DRAFTS=1 forces them on in a production build, used only to compare
// the build against the design, which shows them.
export const SHOW_DRAFT_MARKERS = !import.meta.env.PROD || import.meta.env.VITE_SHOW_DRAFTS === '1';

// Institutes & centres search. false = the live site shows a "being prepared" message and
// development shows clearly-fake sample rows. Set to true when the page reads the real list
// from the ITES database (see BACKEND-LINKS.md, "Institutes and exam centres directory").
export const DIRECTORY_LIVE = false;

// Events. false = the live site hides every link to Events (footer, mobile menu, About strip) and
// /events shows one honest line, until ITES supplies real albums with dates and captions.
// Development always shows the page so you can see what is pending.
export const EVENTS_LIVE = false;
export const SHOW_EVENTS = EVENTS_LIVE || SHOW_DRAFT_MARKERS;
